import InteractiveElement from './interactive-element';
import Link from './private/link';
export default InteractiveElement(Link);
//# sourceMappingURL=interactive-link.js.map